
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/registry",
      function () {
        return require("private-next-pages/registry/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/registry"])
      });
    }
  